(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amb-custom-request"] && !Shopify.designMode) return;
  try {
    
  function initializeAmbCustomRequests(root = document) {
    const params = new URLSearchParams(window.location.search);
    root.querySelectorAll('.amb-custom-request').forEach((form) => {
      const product = form.elements.namedItem('contact[Product]');
      if (product && !product.value) product.value = (params.get('product') || '').slice(0, 160);
      const reference = form.querySelector('[data-amb-product-reference]');
      if (reference) reference.value = (params.get('sku') || '').slice(0, 100);
      const requestType = params.get('request_type');
      const type = form.querySelector('[data-amb-request-type]');
      if (type && ['Custom size', 'Custom piece', 'Similar pieces', 'Artwork inquiry'].includes(requestType)) type.value = requestType;
      const artwork = requestType === 'Artwork inquiry';
      const similar = requestType === 'Similar pieces' || artwork;
      const section = form.closest('[data-amb-request-section]');
      if (artwork) {
        const heading = section?.querySelector('[data-amb-request-heading]');
        const intro = section?.querySelector('[data-amb-request-intro]');
        const help = form.querySelector('[data-amb-similar-help]');
        if (heading) heading.textContent = heading.dataset.artworkHeading;
        if (intro) intro.textContent = intro.dataset.artworkIntro;
        if (help) help.textContent = help.dataset.artworkHelp;
      }
      ['[data-amb-dimensions]', '[data-amb-delivery]'].forEach((selector) => {
        const group = form.querySelector(selector);
        if (!group) return;
        group.hidden = similar;
        group.querySelectorAll('input, select').forEach((input) => { input.disabled = similar; });
      });
      const similarFields = form.querySelector('[data-amb-similar]');
      if (similarFields) {
        similarFields.hidden = !similar;
        similarFields.querySelectorAll('input').forEach((input) => { input.disabled = !similar; });
        const quantity = similarFields.querySelector('[name="contact[Desired quantity]"]');
        if (quantity) {
          quantity.closest('.form-control').hidden = artwork;
          quantity.disabled = !similar || artwork;
          quantity.required = !artwork;
        }
      }
      const height = form.querySelector('[data-amb-height]');
      if (height) height.hidden = requestType !== 'Custom piece';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAmbCustomRequests());
  } else {
    initializeAmbCustomRequests();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAmbCustomRequests(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amb-film')) {
    customElements.define('amb-film', class extends HTMLElement {
      connectedCallback() {
        if (this.abort && !this.abort.signal.aborted) return;
        this.abort = new AbortController();
        this.ready = false;
        this.pausedByUser = false;
        this.seeking = false;
        this.wantsAutoplay = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.video = this.querySelector('video');
        this.playButton = this.querySelector('.amb-film__play');
        this.soundButton = this.querySelector('.amb-film__sound');
        this.seek = this.querySelector('.amb-film__seek');
        const options = { signal: this.abort.signal };
        this.querySelector('.amb-film__controls').hidden = false;
        this.playButton.addEventListener('click', () => {
          if (!this.ready) return;
          this.pausedByUser = this.isPlaying();
          this.pausedByUser ? this.pause() : this.play();
        }, options);
        this.soundButton.addEventListener('click', () => {
          if (!this.ready) return;
          if (this.video) this.video.muted = !this.video.muted;
          else this.player.isMuted() ? this.player.unMute() : this.player.mute();
          this.update();
        }, options);
        this.seek.addEventListener('input', () => {
          this.seeking = true;
          this.seek.style.setProperty('--progress', this.seek.value + '%');
        }, options);
        this.seek.addEventListener('change', () => {
          if (this.ready) {
            const seconds = this.duration() * Number(this.seek.value) / 100;
            if (this.video) this.video.currentTime = seconds;
            else this.player.seekTo(seconds, true);
          }
          this.seeking = false;
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (this.inView && !this.initializing) this.initialize();
          this.syncPlayback();
        }, { threshold: .15 });
        this.observer.observe(this.querySelector('.amb-film__frame'));
        this.timer = setInterval(() => this.update(), 250);
      }
      async initialize() {
        this.initializing = true;
        this.loadTimeout = setTimeout(() => { if (!this.ready) this.showFallback(); }, 15000);
        if (this.video) {
          this.video.controls = false;
          this.video.muted = true;
          this.ready = true;
          this.syncPlayback();
          return;
        }
        try {
          await customElements.whenDefined('video-media');
          if (!window.YT?.Player) {
            window.ambFilmYouTubeReady ||= new Promise((resolve, reject) => {
              const previous = window.onYouTubeIframeAPIReady;
              window.onYouTubeIframeAPIReady = () => { previous?.(); resolve(); };
              const existing = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
              if (!existing) {
                const script = document.createElement('script');
                script.src = 'https://www.youtube.com/iframe_api';
                script.onerror = reject;
                document.head.append(script);
              }
            });
            await window.ambFilmYouTubeReady;
          }
          if (!this.isConnected) return;
          this.player = new window.YT.Player(this.querySelector('.amb-film__embed'), {
            videoId: this.dataset.videoId,
            width: '100%', height: '100%',
            playerVars: { autoplay: 0, controls: 0, playsinline: 1, rel: 0, loop: 1, playlist: this.dataset.videoId, origin: window.location.origin },
            events: {
              onReady: event => {
                event.target.mute();
                event.target.getIframe().title = this.dataset.play;
                event.target.getIframe().tabIndex = -1;
                clearTimeout(this.loadTimeout);
                this.querySelector('.amb-film__controls').hidden = false;
                this.querySelector('.amb-film__fallback').hidden = true;
                this.ready = true;
                this.syncPlayback();
              },
              onStateChange: () => this.update(),
              onError: () => this.showFallback()
            }
          });
        } catch { this.showFallback(); }
      }
      showFallback() {
        this.querySelector('.amb-film__controls').hidden = true;
        this.querySelector('.amb-film__fallback').hidden = false;
      }
      isPlaying() { return this.video ? !this.video.paused : this.player?.getPlayerState?.() === 1; }
      duration() { return (this.video ? this.video.duration : this.player?.getDuration?.()) || 0; }
      play() {
        if (this.video) this.video.play().catch(() => this.update());
        else this.player.playVideo();
      }
      pause() {
        if (this.video) this.video.pause();
        else this.player.pauseVideo();
      }
      syncPlayback() {
        if (!this.ready) return;
        if (!this.inView || document.hidden) this.pause();
        else if (this.wantsAutoplay && !this.pausedByUser) this.play();
      }
      update() {
        if (!this.ready) return;
        const playing = this.isPlaying();
        const muted = this.video ? this.video.muted : this.player.isMuted();
        const current = (this.video ? this.video.currentTime : this.player.getCurrentTime()) || 0;
        const duration = this.duration();
        this.toggleAttribute('data-playing', playing);
        this.toggleAttribute('data-audible', !muted);
        if (playing) this.setAttribute('data-started', '');
        this.playButton.setAttribute('aria-label', playing ? this.dataset.pause : this.dataset.play);
        this.soundButton.setAttribute('aria-label', muted ? this.dataset.unmute : this.dataset.mute);
        this.soundButton.setAttribute('aria-pressed', String(!muted));
        if (!this.seeking) {
          this.seek.value = duration ? current / duration * 100 : 0;
          this.seek.style.setProperty('--progress', this.seek.value + '%');
        }
        const time = seconds => Math.floor(seconds / 60) + ':' + String(Math.floor(seconds % 60)).padStart(2, '0');
        this.querySelector('.amb-film__time').textContent = time(current) + ' / ' + time(duration);
        this.seek.setAttribute('aria-valuetext', time(current) + ' / ' + time(duration));
      }
      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return;
          this.abort.abort();
          this.observer.disconnect();
          clearInterval(this.timer);
          clearTimeout(this.loadTimeout);
          this.player?.destroy();
          this.video?.pause();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-launch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amb-launch')) {
    customElements.define('amb-launch', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const video = this.querySelector('video');
        const button = this.querySelector('.amb-launch__motion');
        if (!video || !button) return;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const update = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; };
        const play = () => { video.muted = true; video.play().catch(update); };
        button.hidden = false;
        video.addEventListener('playing', () => { this.setAttribute('data-video-ready', ''); update(); }, { signal });
        video.addEventListener('pause', update, { signal });
        video.addEventListener('error', () => { this.removeAttribute('data-video-ready'); button.hidden = true; }, { signal });
        button.addEventListener('click', () => { if (video.paused) play(); else video.pause(); }, { signal });
        motion.addEventListener('change', () => { if (motion.matches) video.pause(); }, { signal });
        if (!motion.matches) play();
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.querySelector('video')?.pause(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
